import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { DesignControl } from './design-control';
import { SettingsWrapperControl } from './settings-wrapper-control';
import { TemplateControlService } from './template-control.service';
import { SystemFieldType } from 'src/app/modules/core/store/models';
import { Subscription } from 'rxjs';

const displayControlTemplate = `
<div>
  <table cellspacing="0" cellpadding="0" border="0" style="max-width:800px">
    <tr>
      <td valign="top" class="field-name" style="width: 150px; vertical-align:top; padding-bottom: 4px;font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 700; color: #000000">
        Field Name
      </td>
      <td valign="top" class="field-value" style="width: 650px; vertical-align:top; padding-bottom: 4px; padding-left: 16px; font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 400; color: #000000">
        Field Value
      </td>
    </tr>
  </table>
</div>
`;
const settingsControlTemplate = `
<div style="background-color:var(--neutral-color-000);">
  <table>
    <tr>
      <td style="width: 150px; font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 700; color: #000000">
        <input id="fieldName" class="field-name" type="text" style="
          background-color: var(--neutral-color-000);
          border: none;
          color: #000000;
          font-size: 14px;
          font-weight: 700;
          max-width: 150px;
          outline: none;
          width: 150px" />
      </td>
      <td style="width: auto; font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 400; color: #000000">
        <div class="select is-medium is-primary">
          <select id="fieldValue" class="field-value template-builder-field-value-select" style="color: #000000"/>
        </div>
      </td>
    </tr>
  </table>
</div>
`;

export class FormFieldControl extends DesignControl {
  editSettingsControl: HTMLElement;
  settingsWrapperControl: SettingsWrapperControl;
  saveEdit$: Subscription;
  cancelEdit$: Subscription;

  constructor(document: Document, templateControlService: TemplateControlService) {
    super(document, templateControlService);

    this.controlTemplate = displayControlTemplate;
    this.settingsTemplate = settingsControlTemplate;
    this.controlType = TemplateControlType.FormField;
    this.settingsWrapperControl = this.templateControlService.settingsWrapperControl;
  }

  public edit(): void {
    const displayFieldValueElement = this.controlElement.getElementsByClassName('field-value')[0] as any;
    const textValue = displayFieldValueElement.innerHTML;

    if (this.templateControlService.isPreviewLayout) {
      this.saveEdit$ = this.templateControlService.richTextUpdates$.subscribe(value => {
        displayFieldValueElement.innerHTML = value;
        this.settingsWrapperControl.hide();

        this.saveEdit$.unsubscribe();
        this.cancelEdit$.unsubscribe();
      });

      this.cancelEdit$ = this.templateControlService.richTextCancel$.subscribe(() => {
        this.settingsWrapperControl.hide();

        this.saveEdit$.unsubscribe();
        this.cancelEdit$.unsubscribe();
      });

      this.templateControlService.editRichText(textValue);

      return;
    }

    const fieldDisplayName = this.controlElement.dataset.displayName;
    const fieldUid = this.controlElement.dataset.fieldUid;

    this.editSettingsControl = this.document.createElement('div');
    this.editSettingsControl.innerHTML = this.settingsTemplate;
    this.settingsWrapperControl.setContent(this.editSettingsControl);

    const fieldNameElement = this.editSettingsControl.getElementsByClassName('field-name')[0] as any;
    fieldNameElement.value = fieldDisplayName ?? 'Field Name';
    const fieldValueElement = this.editSettingsControl.getElementsByClassName('field-value')[0] as any;

    const dataset = this.templateControlService.dataset;
    const fields = dataset.schema.fields
      .filter(f => (f.fieldType & SystemFieldType.Hidden) !== SystemFieldType.Hidden)
      .sort((a, b) => (a.displayName > b.displayName ? 1 : -1));

    for (let field of fields) {
      const option = this.document.createElement('option');
      option.value = field.uId;
      option.innerHTML = field.displayName;
      fieldValueElement.appendChild(option);
    }
    fieldValueElement.value = fieldUid;

    fieldValueElement.onchange = this.onFieldChange.bind(this);
  }

  onFieldChange(): void {
    const fieldValueElement = this.editSettingsControl.getElementsByClassName('field-value')[0] as any;
    const fieldUId = fieldValueElement.value;
    if (!!fieldUId) {
      const field = this.templateControlService.dataset.schema.fields.find(f => f.uId === fieldUId);
      if (!!field) {
        const fieldNameElement = this.editSettingsControl.getElementsByClassName('field-name')[0] as any;
        fieldNameElement.value = field.displayName;
      }
    }
  }

  public cancel(): void {
    this.settingsWrapperControl.clearContent();
    this.editSettingsControl = null;
  }

  public save(): void {
    const fieldNameElement = this.editSettingsControl.getElementsByClassName('field-name')[0] as any;
    const fieldValueElement = this.editSettingsControl.getElementsByClassName('field-value')[0] as any;

    const displayFieldNameElement = this.controlElement.getElementsByClassName('field-name')[0] as any;
    const displayFieldValueElement = this.controlElement.getElementsByClassName('field-value')[0] as any;

    this.controlElement.setAttribute('data-display-name', fieldNameElement.value);
    this.controlElement.setAttribute('data-field-uid', fieldValueElement.value);

    displayFieldNameElement.innerHTML = fieldNameElement.value;

    const fieldUId = fieldValueElement.value;
    const field = this.templateControlService.dataset.schema.fields.find(f => f.uId === fieldUId);
    if (!!field) {
      displayFieldValueElement.innerHTML = `{{${field.systemName}}}`;
    }
  }

  public copy(): void {}
}
